import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as Styled from './styles';

export interface LabelBackProps {
  icon: any;
  label: string;
  onClick: () => void;
  selected: boolean;
  disable?: boolean;
  hideIconMobile: boolean;
}

const TypeFilter = ({
  icon,
  label,
  onClick,
  selected,
  disable,
  hideIconMobile,
}: LabelBackProps) => {
  return (
    <Styled.Wrapper selected={selected}>
      <Styled.Container
        onClick={!disable ? onClick : undefined}
        selected={selected}
        disable={disable}
        hideIconMobile={hideIconMobile}
      >
        <Styled.Icon icon={icon} hideIconMobile={hideIconMobile} />
        <Styled.Text hideIconMobile={hideIconMobile}>{label}</Styled.Text>
      </Styled.Container>
    </Styled.Wrapper>
  );
};

export default TypeFilter;
